require('./bootstrap');
require('datatables.net-bs4');
require('datatables.net-buttons-bs4');
import 'components-jqueryui/ui/widget';
import 'components-jqueryui/ui/widgets/autocomplete';
import 'components-jqueryui/ui/widgets/draggable';
require('highlight-within-textarea');
require('gasparesganga-jquery-loading-overlay');
require('./theme');